import React, {useEffect} from "react";
import {KApp, KErrorPage} from "@kopjra/uikit";
import Toolbar from "../containers/Toolbar";
import {Redirect, Route, Switch} from "react-router-dom";
import {ProtectedRoute, ProtectedVerifiedRoute, Routes, RouteType} from "../utils/router";
import {Translate} from "react-redux-i18n";
import UserProfile from "../containers/UserProfile";
import {useAuth0} from "@auth0/auth0-react";
import {initGetTokenFunction} from "../api";
import {BigWaiter} from "./BigWaiter";
import HtmlInteractions from "../containers/HtmlInteractions";
import DataInteractions from "../containers/DataInteractions";
import PdfInteractions from "../containers/PdfInteractions";
import ApiKeys from "../containers/ApiKeys";
import {Credential, User, UserCredits} from "../types/users";
import Timestamps from "../containers/Timestamps";
import {ProductOrder, ProductRouteMap} from "../types";
import ArchetypesCallbacks from "../containers/ArchetypesCallbacks";
import PdfSimpleInteractions from "../containers/PdfSimpleInteractions";
import AesInteractions from "../containers/AesInteractions";

export interface StateProps {
    loadingUser: boolean;
    loggedUser?: User;
    credentials?: Credential[];
    userCredits?: UserCredits;
}

export interface DispatchProps {
    onDoLoggedUser: () => Promise<void>;
    onGetApiKeys: (ignoreAuthResponse?: boolean) => Promise<void>;
    onGetUserCredits: () => Promise<void>;
}

export interface InnerProps {
}

export type Props = StateProps & DispatchProps & InnerProps;

function selectHomeRoute(credentials: Credential[], credits: UserCredits): RouteType {
    if (credentials.length === 0) {
        return Routes.API_KEYS;
    }
    for (const productId of ProductOrder) {
        if (credits[productId].consumedTotal > 0) {
            return ProductRouteMap[productId];
        }
    }
    for (const productId of ProductOrder) {
        if (credits[productId].isAllowed) {
            return ProductRouteMap[productId];
        }
    }
    return Routes.API_KEYS;
}

export const App: React.FC<Props> = ({userCredits, onGetUserCredits, credentials, loggedUser, onGetApiKeys, onDoLoggedUser, loadingUser}) => {
    const {getAccessTokenSilently, isLoading} = useAuth0();
    useEffect(() => {
        initGetTokenFunction(getAccessTokenSilently);
        (async () => {
            await onDoLoggedUser();
            await onGetApiKeys(true);
            if (!userCredits) {
                await onGetUserCredits();
            }
        })().catch();
        // eslint-disable-next-line
    }, [getAccessTokenSilently, onDoLoggedUser, onGetApiKeys, onGetUserCredits]);

    return isLoading || loadingUser ? (
        <BigWaiter/>
    ) : !loggedUser ? (
        <ProtectedRoute path={Routes.ALL}/>
    // ) : !loggedUser.billingProvider ? (
    //     <KApp>
    //         <Toolbar/>
    //         <KErrorPage title={<Translate value="error.page"/>} code={"403"} message={<Translate value="error.forbidden"/>}/>
    //     </KApp>
    ) : (!credentials || !userCredits) ? (
        <BigWaiter/>
    ) : (
        <KApp>
            <Toolbar/>
            <Switch>
                <ProtectedRoute exact={true} path={Routes.HOME} component={() => <Redirect to={selectHomeRoute(credentials, userCredits)}/>}/>

                <ProtectedRoute exact={true} path={Routes.USER_ACCOUNT} component={UserProfile}/>

                <ProtectedVerifiedRoute exact={true} path={Routes.HTML} component={HtmlInteractions}/>
                <ProtectedVerifiedRoute exact={true} path={Routes.DATA} component={DataInteractions}/>
                <ProtectedVerifiedRoute exact={true} path={Routes.PDF} component={PdfInteractions}/>
                <ProtectedVerifiedRoute exact={true} path={Routes.AES} component={AesInteractions}/>
                <ProtectedVerifiedRoute exact={true} path={Routes.PDF_SIMPLE} component={PdfSimpleInteractions}/>
                <ProtectedVerifiedRoute exact={true} path={Routes.TIMESTAMP} component={Timestamps}/>
                <ProtectedVerifiedRoute exact={true} path={Routes.API_KEYS} component={ApiKeys}/>
                <ProtectedVerifiedRoute exact={true} path={Routes.CALL_ARCH} component={ArchetypesCallbacks}/>

                <Route path={Routes.ALL} render={() => <KErrorPage title={<Translate value="error.page"/>} code={"404"} message={<Translate value="error.notFound"/>}/>}/>
            </Switch>
        </KApp>
    );
}
